export default {
  audioFile: {
    fileSize: 'File Size',
    musicDuration: 'Music Duration',
    cutting: 'Clip',
    duration: 'Acquiring...',
  },
  audioLoop: {
    title: 'play',
    playSetting: 'Playback Settings',
    autoPlay: 'autoplay upon open',
    cycles: 'Cycles',
    formItemList: {
      loopNumber: 'Times',
      loop: 'Loop',
    },
  },
  audioSetting: {
    soundEffect: 'Sound Effects',
    volume: 'Volume',
  },
  audioEditor: {
    argumentsAreEmpty: 'URL is a must-pass parameter',
  },
  dialog: {
    title: 'Audio Clip',
    soundTitle: 'Sound clipping',
  },
}
